// Copy editável da landing page (Avance). Troque textos, CTAs e contato aqui
// — os componentes em src/components/landing/ só renderizam o que está aqui.
//
// A landing tem um conteúdo padrão genérico (estabelecimentos de beleza em
// geral, ./niches/geral.js) exibido na home, mais três nichos específicos
// (barbearia, salão de beleza, clínica de estética — links "Segmentos" no
// rodapé, ver footer.columns abaixo). O texto de cada nicho vive em
// ./niches/{geral,barbearia,salao,clinica}.js; este arquivo resolve qual
// nicho está ativo (ver ./niches/index.js) e reexporta o conteúdo dele,
// então os componentes abaixo continuam importando os mesmos nomes de sempre
// sem saber que existe mais de um nicho.
import { NICHE_LIST, resolveNiche, nicheHref } from './niches/index.js'

// appointments-frontend (app autenticado) roda em outro projeto/domínio — os
// links de login e documentos legais abaixo apontam pra lá via VITE_APP_URL
// (ver .env.example).
export const appUrl = (import.meta.env.VITE_APP_URL || 'http://localhost:8081').replace(/\/$/, '')

// appointments-backend — usado só pelo modal de cadastro (POST /api/public/tenants),
// a única chamada de API que esta landing page faz diretamente.
export const apiUrl = (import.meta.env.VITE_API_URL || 'http://localhost:3001').replace(/\/$/, '')

const niche = resolveNiche()

export const currentNiche = niche

// 'dark' (padrão) ou 'light' — controla o visual de header, hero e rodapé
// (únicos trechos com fundo escuro na página). Ver comentário em cada
// arquivo de nicho em ./niches/.
export const theme = niche.theme || 'dark'

// TODO: substituir pelo WhatsApp real antes de publicar.
export const contact = {
  whatsappNumber: '5500000000000', // TODO: número real, formato 55DDDNÚMERO
  whatsappMessage: niche.whatsappMessage,
  email: 'contato@avancegestor.com.br',
}

export const whatsappHref =
  `https://wa.me/${contact.whatsappNumber}?text=${encodeURIComponent(contact.whatsappMessage)}`

export const seo = niche.seo
export const hero = niche.hero
export const heroMock = niche.heroMock
export const trustBadges = niche.trustBadges
export const painPoints = niche.painPoints
export const screensPreview = niche.screensPreview
export const featureGridSection = niche.featureGridSection
export const features = niche.features
export const whatsappNotifications = niche.whatsappNotifications
export const bookingShowcase = niche.bookingShowcase
export const financeShowcase = niche.financeShowcase
export const loyaltyShowcase = niche.loyaltyShowcase
export const audienceSection = niche.audienceSection
export const audiences = niche.audiences
export const faqSection = niche.faqSection
export const faq = niche.faq
export const signupCopy = niche.signupCopy

// Copy fixa da seção "Planos" — os planos em si (nome, preço, benefícios,
// selo e CTA) vêm de GET /api/public/plans (cadastrados pelo platform owner
// no appointments-frontend, mesmo catálogo para todos os nichos), ver
// LandingPlans.vue.
export const plans = niche.plans

export const midCta = niche.midCta
export const finalCta = niche.finalCta

// Seção "veja adaptado ao seu segmento" (LandingSegmentSwitcher.vue),
// exibida em todas as páginas — inclusive nas de nicho específico, onde o
// segmento correspondente aparece marcado como ativo. Reaproveita o mesmo
// NICHE_LIST/nicheHref do rodapé, então os links levam pro mesmo lugar.
export const segmentSwitcher = {
  eyebrow: 'Feito sob medida',
  title: 'Veja o Avance adaptado para o seu tipo de negócio',
  segments: NICHE_LIST.map((n) => ({
    slug: n.slug,
    label: n.navLabel,
    desc: n.segmentCard.desc,
    href: nicheHref(n.slug),
    active: n.slug === currentNiche.slug,
  })),
}

export const footer = {
  tagline: niche.footerTagline,
  contactEmail: contact.email,
  columns: [
    {
      title: 'Segmentos',
      // Troca de nicho: recarrega a home com `?nicho=...` (ver
      // ./niches/index.js) — cada link mostra a landing com o conteúdo
      // daquele segmento.
      links: NICHE_LIST.map((n) => ({ label: n.navLabel, href: nicheHref(n.slug) })),
    },
    {
      title: 'Produto',
      links: [
        { label: 'Funcionalidades', href: '/#recursos' },
        // Seção desativada em App.vue (LandingWhatsAppNotifications) — reativar junto.
        // { label: 'Notificações WhatsApp', href: '#notificacoes-whatsapp' },
        { label: 'Planos', href: '/#planos' },
        { label: 'FAQ', href: '/#faq' },
        { label: 'Blog', href: '/blog' },
      ],
    },
    {
      title: 'Legal',
      // legalDocument abre o texto num modal aqui mesmo (ver
      // LegalDocumentModal.vue); o href continua como fallback pra abrir em
      // nova aba / copiar link.
      links: [
        { label: 'Termos de Uso', href: `${appUrl}/termos`, legalDocument: 'terms' },
        { label: 'Política de Privacidade', href: `${appUrl}/privacidade`, legalDocument: 'privacy' },
      ],
    },
    {
      title: 'Conta',
      links: [
        { label: 'Entrar', href: `${appUrl}/login`, login: true },
      ],
    },
  ],
}
